module.exports = __webpack_public_path__ + "img/0Q3A7086_L_WoodMatted_MockedUp.05cdd18e.jpg";